import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const Education = () => {

    const navigate = useNavigate();

    // Demo dataset with legit schools (state → city → schools)
    const schoolData = {
        "Andaman & Nicobar Islands": {
            "ANDAMANS": [
                "GOVT SENIOR SECONDARY SCHOOL RAMAKRISHNAPUR",
            ],
        },
        "Andhra Pradesh": {
            "ANANTAPUR": [
                "MPPS KARIDASANAHALLI",
            ],
        },
        "Arunachal Pradesh": {
            "ANJAW": [
                "GOVT.MID.SCHOOL,METANGLIANG",
            ],
        },
        "Assam": {
            "BAJALI": [
                "1741 DAIRABARI LPS",
            ],
        },
        "Bihar": {
            "PURBA CHAMPARAN": [
                "UMS BALA KOTHI",
            ],
        },
        "Chhattisgarh": {
            "BILASPUR": [
                "GOVT. PS DODKI",
            ],
        },
        "Delhi": {
            "New Delhi": [
                "Delhi Public School, R.K. Puram",
                "The Mother's International School",
                "Modern School, Barakhamba Road",
            ],
            "Dwarka": [
                "Mount Carmel School",
                "Bal Bharti Public School",
            ],
        },
        "Goa": {
            "NORTH GOA": [
                "VIDYANIKETAN HS, CALANGUTE",
            ],
        },
        "Gujarat": {
            "AHMEDABAD": [
                "SADHNA VINAY MANDIR(SOLAROAD)(ENG)",
            ],
        },
        "Haryana": {
            "KAITHAL": [
                "ST. LAWRENCE ENGLISH SCHOOL AZIMGARH",
            ],
        },
        "Himachal Pradesh": {
            "KANGRA": [
                "GPS CHHANNI",
            ],
        },
        "Jammu & Kashmir": {
            "JAMMU": [
                "THE ROYAL  INDIAN SCHOOL JOURIAN JAMMU",
            ],
        },
        "Jharkhand": {
            "KODARMA": [
                "BHARTI SHISHU NIKETAN BHELWATANR",
            ],
        },
        "Karnataka": {
            "BALLARI": [
                "GLPS INDRA NAGAR KOLUR CROSS",
            ],
        },
        "Kerala": {
            "KOZHIKODE": [
                "G.H.S.S. KUNDUPARAMBA",
            ],
        },
        "Madhya Pradesh": {
            "DEWAS": [
                "GOVT. HS IKLERA",
            ],
        },
        "Maharashtra": {
            "Mumbai": [
                "Bombay Scottish School, Mahim",
                "Cathedral and John Connon School",
                "Dhirubhai Ambani International School",
            ],
            "Pune": [
                "St. Mary’s School",
                "Delhi Public School, Pune",
            ],
        },
        "Manipur": {
            "UKHRUL": [
                "SANAKEITHEL CHINGSHANG HS",
            ],
        },
        "Meghalaya": {
            "SOUTH WEST KHASI HILLS": [
                "RANGJADONG GOVT.LPS",
            ],
        },
        "Mizoram": {
            "CHAMPHAI": [
                "GOVT. P/S-VI- CHAMPHAI",
            ],
        },
        "Nagaland": {
            "DIMAPUR": [
                "GOVERNMENT MIDDLE SCHOOL SANGTAMTILLA",
            ],
        },
        "Odisha": {
            "BALASORE": [
                "H.K. GOVT. NODAL UP SCHOOL, RELLA",
            ],
        },
        "Punjab": {
            "GURDASPUR": [
                "GPS SADHU CHAK",
            ],
        },
        "Rajasthan": {
            "BIKANER": [
                "G.P.S. KUDSU",
            ],
        },
    };

    const [selectedState, setSelectedState] = useState("");
    const [selectedCity, setSelectedCity] = useState("");
    const [selectedSchool, setSelectedSchool] = useState("");
    const [schoolFee, setSchoolFee] = useState("");
    const [showPopup, setShowPopup] = useState(false);
    const [selectedPayment, setSelectedPayment] = useState("");
    const [showSuccessPopup, setShowSuccessPopup] = useState(false);

    const handleContinue = () => {
        if (!selectedState || !selectedCity || !selectedSchool || !schoolFee) {
            alert("Please fill all fields before continuing.");
            return;
        }
        setShowPopup(true);
    };

    const handlePaymentSubmit = () => {
        if (!selectedPayment) {
            alert("Please select a payment method.");
            return;
        }
        setShowPopup(false);
        setShowSuccessPopup(true);
    };

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 p-6">
            <div className="bg-white shadow-md rounded-2xl p-6 w-full max-w-md">
                <h2 className="text-2xl font-semibold text-center mb-6 text-blue-600">
                    🎓 Education Details
                </h2>

                {/* State dropdown */}
                <label className="block mb-2 font-medium">Select State</label>
                <select
                    className="w-full border rounded-lg p-2 mb-4"
                    value={selectedState}
                    onChange={(e) => {
                        setSelectedState(e.target.value);
                        setSelectedCity("");
                        setSelectedSchool("");
                    }}
                >
                    <option value="">-- Select State --</option>
                    {Object.keys(schoolData).map((state) => (
                        <option key={state} value={state}>
                            {state}
                        </option>
                    ))}
                </select>

                {/* City dropdown */}
                <label className="block mb-2 font-medium">Select City</label>
                <select
                    className="w-full border rounded-lg p-2 mb-4"
                    value={selectedCity}
                    onChange={(e) => {
                        setSelectedCity(e.target.value);
                        setSelectedSchool("");
                    }}
                    disabled={!selectedState}
                >
                    <option value="">-- Select City --</option>
                    {selectedState &&
                        Object.keys(schoolData[selectedState]).map((city) => (
                            <option key={city} value={city}>
                                {city}
                            </option>
                        ))}
                </select>

                {/* School dropdown */}
                <label className="block mb-2 font-medium">Select School</label>
                <select
                    className="w-full border rounded-lg p-2 mb-4"
                    value={selectedSchool}
                    onChange={(e) => setSelectedSchool(e.target.value)}
                    disabled={!selectedCity}
                >
                    <option value="">-- Select School --</option>
                    {selectedCity &&
                        schoolData[selectedState][selectedCity].map((school) => (
                            <option key={school} value={school}>
                                {school}
                            </option>
                        ))}
                </select>

                {/* School fee input */}
                <label className="block mb-2 font-medium">Enter School Fee (₹)</label>
                <input
                    type="number"
                    className="w-full border rounded-lg p-2 mb-4"
                    placeholder="Enter amount"
                    value={schoolFee}
                    onChange={(e) => setSchoolFee(e.target.value)}
                />

                {/* Continue button */}
                <button
                    onClick={handleContinue}
                    className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition"
                >
                    Continue
                </button>
            </div>

            {/* Payment Method Popup */}
            {showPopup && (
                <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center">
                    <div className="bg-white rounded-2xl shadow-lg w-96 p-6">
                        <h3 className="text-lg font-semibold text-center mb-4 text-gray-700">
                            Select Payment Method
                        </h3>
                        <div className="flex flex-col gap-3">
                            {["Wallet", "UPI", "Credit Card", "Debit Card", "Net Banking"].map(
                                (method) => (
                                    <label
                                        key={method}
                                        className={`border rounded-lg p-3 cursor-pointer hover:bg-blue-50 ${selectedPayment === method
                                            ? "border-blue-600 bg-blue-50"
                                            : "border-gray-300"
                                            }`}
                                    >
                                        <input
                                            type="radio"
                                            name="payment"
                                            value={method}
                                            checked={selectedPayment === method}
                                            onChange={(e) => setSelectedPayment(e.target.value)}
                                            className="mr-2"
                                        />
                                        {method}
                                    </label>
                                )
                            )}
                        </div>
                        <div className="flex justify-end gap-3 mt-5">
                            <button
                                onClick={() => setShowPopup(false)}
                                className="px-4 py-2 rounded-lg border border-gray-300 hover:bg-gray-100"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handlePaymentSubmit}
                                className="px-4 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700"
                            >
                                Confirm
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {showSuccessPopup && (
                <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center">
                    <div className="bg-white rounded-2xl shadow-lg w-96 p-6">
                        <div className="text-center">
                            <div className="text-5xl mb-4">✅</div>
                            <h3 className="text-xl font-semibold mb-4 text-gray-800">
                                Payment Successful!
                            </h3>
                            <div className="text-left bg-gray-50 rounded-lg p-4 mb-4">
                                <p className="mb-2"><strong>Payment Method:</strong> {selectedPayment}</p>
                                <p className="mb-2"><strong>State:</strong> {selectedState}</p>
                                <p className="mb-2"><strong>City:</strong> {selectedCity}</p>
                                <p className="mb-2"><strong>School:</strong> {selectedSchool}</p>
                                <p><strong>Fee:</strong> ₹{schoolFee}</p>
                            </div>
                            <button
                                onClick={() => {
                                    setShowSuccessPopup(false);
                                    setSelectedState("");
                                    setSelectedCity("");
                                    setSelectedSchool("");
                                    setSchoolFee("");
                                    setSelectedPayment("");
                                    navigate("/retailerdashboard");
                                }}
                                className="w-full px-4 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Education;
